import React from 'react'
import Col from 'react-bootstrap/esm/Col';
import Footer from './Footer';
import NavbarComp from './NavbarComp';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import FloatingLabel from 'react-bootstrap/FloatingLabel';
import Figure from 'react-bootstrap/Figure';

const Contact = () => {
    return ( 
        <div className='bg-light animated fadeInUp ease-in-quint d-1 a-2' >
<NavbarComp />
<div>
<h1 className='exee mt-5 text-center'>Get in Touch</h1>
<p className=' text-center mt-2 text-muted'>We’d love to hear from you. 
For more information about our programs or our organization, please contact us using the form below.</p>
<i className=" icons fa fa-envelope-open-o fs-1  offset-3 offset-lg-4 mt-4 " aria-hidden="true"></i><span className='ms-1'>EMAIL: info@amcosa.org</span>
<Row>
<Col sm={6}>
<Form>
    
<Form.Group className="mb-3" controlId="formBasicEmail">
        <Form.Label></Form.Label>
        <Form.Control type="text" placeholder="Enter full name" />
      </Form.Group>
      
      <Form.Group className="mb-3" controlId="formBasicEmail">
        <Form.Label></Form.Label>
        <Form.Control type="email" placeholder="Enter your email" />
      </Form.Group>

      <Form.Group className="mb-3" controlId="formBasicEmail">
        <Form.Label></Form.Label>
        <Form.Control type="number" placeholder="Enter your phone number" />
      </Form.Group>
    </Form>
    
         <>
      <FloatingLabel
        controlId="floatingTextarea"
        label="Comments"
        className="mb-3"
      >
      </FloatingLabel>
      <FloatingLabel controlId="floatingTextarea2" label="Comments">
        <Form.Control
          as="textarea"
          placeholder="Leave a comment here"
          style={{ height: '100px' }}
        />
      </FloatingLabel>
       
    </>
</Col>
<Col sm={6}>
<Figure>
      <Figure.Image
        width={1000}
        height={400}
        alt="171x180"
        src={require('../video/am7.jpg')}
      />
      
    </Figure>

</Col>


</Row>


</div>


<div>
 <Footer />
</div>
        </div>
     );
}
 
export default Contact;

